import { AuthService } from 'src/app/services/auth.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CustomerPaymentMethodModel } from 'src/app/models/Profile/CustomerPaymentMethodModel';


@Component({
  selector: 'app-edit-payment-info',
  templateUrl: './edit-payment-info.component.html',
  styleUrls: ['./edit-payment-info.component.css']
})
export class EditPaymentInfoComponent implements OnInit {


  faTimesCircle = faTimesCircle;
  customerPaymentMethod: CustomerPaymentMethodModel;



  constructor(
    private dialogRef: MatDialogRef<EditPaymentInfoComponent>,
    @Inject(MAT_DIALOG_DATA) private data,
    private dialog: MatDialog,
    private authService: AuthService
  ) {

  }

  form: FormGroup;


  ngOnInit() {
    if (this.data != null && this.data.customerPaymentMethod != null) {
      let paymentMethod = this.data.customerPaymentMethod as CustomerPaymentMethodModel;
      this.customerPaymentMethod = paymentMethod;
      this.form = new FormGroup({
        customerName: new FormControl(paymentMethod.name, Validators.required),
        cardNo: new FormControl(paymentMethod.number, Validators.required),
        securityCode: new FormControl(paymentMethod.cvv, Validators.required),
        expiryDateMonth: new FormControl(paymentMethod.expiryMonth, Validators.required),
        expiryDateYear: new FormControl(paymentMethod.expiryYear, Validators.required),
      });
    }

  }

  onSubmit() {
    let updateModel = this.getUpdateModel();

    this.authService.updateCustomerPaymentMethods(updateModel).subscribe(res => {
      this.dialogRef.close({ success: true });
    })

  }
  getUpdateModel() {
    this.customerPaymentMethod.name = this.form.value["customerName"];
    this.customerPaymentMethod.number = this.form.value["cardNo"];
    this.customerPaymentMethod.cvv = this.form.value["securityCode"];
    this.customerPaymentMethod.expiryMonth = this.form.value["expiryDateMonth"];
    this.customerPaymentMethod.expiryYear = this.form.value["expiryDateYear"];
    return this.customerPaymentMethod;
  }

  close(): void {
    this.dialogRef.close();
  }
}


